import { render, staticRenderFns } from "./VSelectHeadOfCareer.vue?vue&type=template&id=b4164534&"
import script from "./VSelectHeadOfCareer.vue?vue&type=script&lang=js&"
export * from "./VSelectHeadOfCareer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4164534')) {
      api.createRecord('b4164534', component.options)
    } else {
      api.reload('b4164534', component.options)
    }
    module.hot.accept("./VSelectHeadOfCareer.vue?vue&type=template&id=b4164534&", function () {
      api.rerender('b4164534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/61980520-8/components/VSelectHeadOfCareer.vue"
export default component.exports